import { CHANGE_USER_PASSWORD, CHANGE_USER_PASSWORD_SUCCESS, CHANGE_USER_PASSWORD_FAILURE } from "../actionTypes";

export const changeUserPassword = (payload) => ({
  type: CHANGE_USER_PASSWORD,
  payload,
});

export const changeUserPasswordSuccess = () => ({
  type: CHANGE_USER_PASSWORD_SUCCESS,
});

export const changeUserPasswordFailure = () => ({
  type: CHANGE_USER_PASSWORD_FAILURE,
});
